type GetProvidersMedicalGuideParamsV3 = {
	dsEspecialidade?: string;
	cd_procedimento?: string;
	cdUf?: string;
	nmCidade?: string;
	coordenadas?: string;
	dsTipo: string;
	nmPrestador?: string;
	retornoAgrupado: boolean;
	tpRede?: NetworkTypeEnum;
	signal?: AbortSignal;
	distancia?: string;
	page: number;
	limit: number;
	firstNetworkType?: FirstNetworkTypeEnum;
};

type ProvidersMedicalQualifications = {
	cdTipoQualificacao: number;
	dsTipoQualificacao: string;
	dsEspecialidade: string;
};

type ProvidersMedicalModalities = {
	consulta: string;
	internacao: string;
	maternidade: string;
};

export enum FirstNetworkTypeEnum {
	SELF_NETWORK = 'OWN_NETWORK',
	ACCREDITED_NETWORK = 'ACCREDITED_NETWORK',
}

enum NetworkTypeEnum {
	ALL = 0,
	SELF_NETWORK = 1,
	ACCREDITED_NETWORK = 2,
}

type AppointmentHour = {
	nmDiaSemana: string;
	hrInicialPrimeiroTurno: string | null;
	hrFinalPrimeiroTurno: string | null;
	hrInicialSegundoTurno: string | null;
	hrFinalSegundoTurno: string | null;
};

type ProvidersMedicalGuide = {
	codigo: number;
	nmPrestador: string;
	logradouro: string;
	dsComplEndereco: string | null;
	nmBairro: string;
	nmCidade: string;
	cdUf: string;
	tipo: string;
	tipoConsulta: string;
	tipoRede?: NetworkTypeEnum;
	nuTelefone: string;
	tipoPessoa: number;
	site: string;
	qualificacoes: ProvidersMedicalQualifications[];
	modalidade: ProvidersMedicalModalities | null;
	crmcnes: string | null;
	cep: string;
	cgccpf: string;
	nmFantasia: string;
	nmLocal: string | null;
	distancia: number;
	ordemRR: number | null;
	horariosAtendimento: AppointmentHour[] | null;
};

type GetProvidersMedicalGuideModelV3 = {
	prestadores: ProvidersMedicalGuide[];
	pageNumber: number;
	limit: number;
	hasNextPage: boolean;
};

interface GetProvidersMedicalGuideV3 {
	get: (params: GetProvidersMedicalGuideParamsV3) => Promise<GetProvidersMedicalGuideModelV3>;
}

export type {
	GetProvidersMedicalGuideParamsV3,
	ProvidersMedicalModalities,
	ProvidersMedicalGuide,
	GetProvidersMedicalGuideModelV3,
	GetProvidersMedicalGuideV3,
	AppointmentHour,
};

export {NetworkTypeEnum};
